import React from 'react';
import { observer } from 'mobx-react';
import { setPostImage } from '@images/imageUrls';
import { useFeedbackAttachmentActions } from '../FeedbackAttachmentContext';
import styles from './index.module.scss';

const PCFeedbackAttachmentDisplay: React.FC = () => {
    const {
        imageAttachments,
        videoUrl,
        hasVideo,
        removeImage,
        removeVideo,
    } = useFeedbackAttachmentActions();

    if (!imageAttachments.length && !hasVideo) {
        return null;
    }

    return (
        <div className={styles.uploadList}>
            {imageAttachments.map((item) => (
                <div key={item.id} className={styles.uploadItem}>
                    <img src={item.url} alt="" className={styles.previewImage} />
                    <button
                        type="button"
                        className={styles.deleteBtn}
                        onClick={() => removeImage(item.id)}
                    >
                        <img src={setPostImage.delete} alt="删除" width={18} height={18} />
                    </button>
                </div>
            ))}

            {hasVideo && videoUrl && (
                <div className={styles.uploadItem}>
                    <video src={videoUrl} className={styles.previewVideo} controls />
                    <button
                        type="button"
                        className={styles.deleteBtn}
                        onClick={removeVideo}
                    >
                        <img src={setPostImage.delete} alt="删除" width={18} height={18} />
                    </button>
                </div>
            )}
        </div>
    );
};

export default observer(PCFeedbackAttachmentDisplay);
